import { ToolbarPlaneIcon } from '@editor/assets/icons'
import { EDITOR_TOOLS, EDITOR_TOOLS_LABELS, ProductTypes } from '@editor/config/constants'
import { CursorState } from '@editor/config/constants/cursor'
import { EditorTool, ToolbarCategory } from '@editor/interfaces/editor'
import { UserInfo } from '@editor/interfaces/user'

import useEditor from './hooks/useEditor'
import useElementsPanel from './hooks/useElementsPanel'
import useMainCanvas from './hooks/useMainCanvas'

const RebarDetection: EditorTool = {
  key: EDITOR_TOOLS.PLANE,
  cursor: CursorState.CROSSHAIR,
  authCheck: (userProfile: UserInfo | null, isAllowedToModify: boolean) =>
    ((userProfile?.owned_products.includes(ProductTypes.Hatsuly) ||
      userProfile?.owned_products.includes(ProductTypes.Markly)) &&
      isAllowedToModify) ||
    false,
  toolbar: {
    icon: <ToolbarPlaneIcon width="50%" height="50%" />,
    label: EDITOR_TOOLS_LABELS.PLANE,
    category: ToolbarCategory.Generate,
  },
  hooks: {
    useEditor,
    useMainCanvas,
    useElementsPanel,
  },
  config: {
    anchor: {
      notPlaceableOnObjects: true,
    },
  },
}

export default RebarDetection
